import React from 'react';
import Settings from '../../components/Settings/Settings';
import { updateUserLocale, updateUserUsername } from '../../store/actions/backendProfile';
import { copyToClipboard } from '../../store/actions/trainer';
import { getProfileTelephonyId } from '../../store/selectors/profile';
import { displayTelephonyId, hidePersonalUsername } from '../../store/selectors/trainer';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import type { RootState } from '../../store/types';

function SettingsContainer() {
    const dispatch = useAppDispatch();
    const stateProps = useAppSelector((state: RootState) => ({
        locale: state.user.locale,
        isCallStarted: state.trainer.isStarted,
        daemonVersion: state.trainer.daemonVersion,
        telephonyId: getProfileTelephonyId(state),
        displayTelephonyId: displayTelephonyId(state),
        hidePersonalUsername: hidePersonalUsername(state),
        callIds: (state._debug.callIds || []).map(item => ({
            callId: item.callId,
            timestamp: String(item.timestamp)
        })),
        personalUsername: state.user.personalUsername || '',
        pending: state.user.pending,
        errorCode: state.user.errorCode == null ? null : String(state.user.errorCode),
        initialized: state.user.initialized,
        micDeviceNotAvailable: state.trainer.micDeviceNotAvailable
    }));

    return (
        <Settings
            {...stateProps}
            setLocale={(locale: string) => dispatch(updateUserLocale(locale))}
            updateUsernameRequest={(nickName: string) => dispatch(updateUserUsername(nickName))}
            copyToClipboard={(payload: string) => dispatch(copyToClipboard(payload))}
        />
    );
}

export default SettingsContainer;
